/**
 * platform ที่ยังไม่มี account เลย ยุบเหลือแถว chip
 *
 * ของเดิมโชว์ card เต็มใบให้ทุก platform ตลอดเวลา ทั้งที่ workspace ส่วนใหญ่ต่อ
 * จริงแค่ 2-3 อัน — ที่เหลือคือ card เปล่าที่กินพื้นที่เท่ากับของที่ใช้งานจริง
 *
 * @module components/settings/AddConnectionPicker
 */

import React from "react";
import { useTranslation } from "react-i18next";
import type { PlatformConfig } from "@/types";

export interface AddConnectionPickerProps {
  platforms: PlatformConfig[];
  onConnect: (platform: PlatformConfig) => void;
  /**
   * empty state มีหัวข้อของตัวเองอยู่แล้ว ("Connect your first ad account") การ
   * โชว์ "Add a connection" ซ้อนใต้มันอีกชั้นคือหัวข้อสองอันซ้อนกันที่บอกเรื่อง
   * เดียวกัน — ที่นั่นส่ง false
   */
  showHeading?: boolean;
}

export const AddConnectionPicker: React.FC<AddConnectionPickerProps> = ({
  platforms,
  onConnect,
  showHeading = true,
}) => {
  const { t } = useTranslation();
  if (platforms.length === 0) return null;

  return (
    <section className="space-y-2">
      {showHeading && (
        <h2 className="text-sm font-semibold text-ink-900">{t('settings.addConnection')}</h2>
      )}
      <div className="flex flex-wrap gap-2">
        {platforms.map((platform) => (
          <button
            key={platform.type}
            type="button"
            onClick={() => onConnect(platform)}
            className="inline-flex items-center gap-2 px-3 py-1.5 text-sm rounded-full border border-neutral-300 bg-white hover:bg-neutral-50"
          >
            <span aria-hidden="true">{platform.icon}</span>
            {platform.displayName}
          </button>
        ))}
      </div>
    </section>
  );
};

export default AddConnectionPicker;
